export const CapterraLogo = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.0234375 5.21169L5.19781 5.2127L8.34417 5.21323V2.15253L0.0234375 5.21169Z" fill="#FF9D28" />
    <path d="M8.34473 2.15229V12.9581L12.2745 0.707031L8.34473 2.15229Z" fill="#68C5ED" />
    <path d="M8.3446 5.21275L5.19824 5.21222L8.3446 12.9579V5.21275Z" fill="#044D80" />
    <path d="M0.0234375 5.21143L6.00466 7.19987L5.19781 5.21244L0.0234375 5.21143Z" fill="#E54747" />
  </svg>
);
